<template>
    <div>
        <HeaderBox index="5"></HeaderBox>
        <div class="split"></div>
        <section>
            <article class="fl">
                
            </article>
            <AsideBox></AsideBox>
        </section>
        <FooterBox></FooterBox>
    </div>
</template>

<script>
import HeaderBox from '../components/HeaderBox'
import AsideBox from '../components/AsideBox'
import FooterBox from '../components/FooterBox'
export default {
    components: {HeaderBox,AsideBox,FooterBox}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/AboutmeView.vue